import { AppStore, getUserProfile } from '@alfresco/aca-shared/store';
import { AppConfigService, AuthenticationService, AuthGuardBase, StorageService } from '@alfresco/adf-core';
import { ProfileState } from '@alfresco/adf-extensions';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { InitService } from '../services/init.service';

@Injectable({ providedIn: 'root' })
export class ProfileGuard extends AuthGuardBase implements CanActivate {

    profile$: Observable<ProfileState>;

    constructor(
        authenticationService: AuthenticationService, 
        router: Router, 
        appConfigService: AppConfigService, 
        dialog: MatDialog, 
        storageService: StorageService,
        private store: Store<AppStore>,
        private initService: InitService
        
    ) {
        super(authenticationService, router, appConfigService, dialog, storageService);
        this.profile$ = this.store.select(getUserProfile);
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.checkLogin(route, '') as Observable<boolean>;
    }

    checkLogin(_activeRoute: ActivatedRouteSnapshot, _redirectUrl: string): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.profile$.pipe(
            filter(profile => !!profile && !!profile.id),
            map(() => {
                if (this.initService.initState.hideProfile) {
                    this.router.navigate(['']);
                }
                return true;
            })
        );
    }
}
